// Leaflet plugins polyfills
// This file ensures leaflet.heat and leaflet.markercluster are included in all builds
import 'leaflet';
import 'leaflet.heat';
import 'leaflet.markercluster';

export {};
